import type { PropsWithChildren, ReactNode } from 'react'
import { useState } from 'react'
import UISwitch from 'src/components/ui/Switch'
import { WORKBENCH_OVERLAY_ID } from 'src/layouts/WorkbenchLayout'
import { cx } from 'src/utils/cx'
import type { UITooltipHelpIconProps } from '../HelpIcon'
import { UITooltipHelpIcon } from '../HelpIcon'

export default function GeneratorControlSection(
  props: {
    title?: ReactNode
    help?: ReactNode
    titleSlot?: ReactNode
    toggle?: boolean
    onToggle?: (value: boolean) => void
    debug?: any
    helpIconProps?: UITooltipHelpIconProps
    compact?: boolean
  } & StyleProps &
    PropsWithChildren,
) {
  const helpIcon = props.help ? (
    <UITooltipHelpIcon
      TooltipProps={{
        placement: 'start',
        UNSTABLE_portalContainer:
          document.getElementById(WORKBENCH_OVERLAY_ID)!,
        // TODO: add a cross-offset to move the tooltip display away from the control section
      }}
      {...props.helpIconProps}
    >
      {props.help}
    </UITooltipHelpIcon>
  ) : null

  return (
    <section
      className={cx(
        props.compact ? 'p-0' : 'p-4',
        'flex flex-col text-sm',
        props.className,
      )}
      style={props.style}
    >
      {props.title && (
        <header className="flex items-center gap-2 relative">
          <h2 className={cx('flex-none', 'font-semibold')}>{props.title}</h2>
          {helpIcon}
          {props.titleSlot}
          {props.toggle != null && (
            <UISwitch
              isSelected={props.toggle}
              onChange={props.onToggle}
              className="flex-none ml-auto"
            />
          )}
        </header>
      )}
      {props.children && props.toggle !== false && (
        <div className={cx('flex flex-col gap-2', props.title && 'mt-2')}>
          {props.children}
        </div>
      )}
    </section>
  )
}

export function ControlSectionTest() {
  const [toggle, setToggle] = useState(true)

  return (
    <>
      <GeneratorControlSection>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus
        architecto aspernatur aut culpa dolores eius eos eum, ipsam nisi numquam
        quae quo quod rem rerum tempora temporibus voluptas voluptatem.
        Blanditiis?
      </GeneratorControlSection>
      <GeneratorControlSection title="Test" help="Help">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt dicta
        doloribus ea eaque illum iusto laboriosam magnam nam nisi perspiciatis
        quae quis ratione repellendus tempore unde, velit veritatis voluptate
        voluptatibus?
      </GeneratorControlSection>
      <GeneratorControlSection
        title="Test"
        help="Help"
        toggle={toggle}
        onToggle={setToggle}
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda
          corporis debitis dolorem excepturi fugiat ipsum iste, quaerat
          reprehenderit sequi voluptate? Ab aut commodi consequatur consequuntur
          id itaque repudiandae tempora voluptates.
        </p>
      </GeneratorControlSection>
      <GeneratorControlSection
        title="Test"
        help="Help"
        toggle={toggle}
        onToggle={setToggle}
        titleSlot="Lorem ipsum"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta
          doloremque eveniet fugiat illo mollitia, necessitatibus nesciunt
          obcaecati officia reiciendis temporibus. Atque consequatur culpa ea
          nobis pariatur qui quidem velit vitae.
        </p>
      </GeneratorControlSection>
    </>
  )
}
